import { type FC } from "react";
import { OAuthCardError } from "@/pages/oauth-consent/oauth-card-error";

import { OAuthConsentPageForm } from "@/pages/oauth-consent/oauth-consent-page-form";
import type { OAuthCardProps } from "@/pages/oauth-consent/oauth-card";

interface OAuthConsentPageContentProps {
  redirectUri: string | null;
  clientId: string | null;
  state: string | null;
  scopeStr: string | null;
  responseType: string | null;
  appName: string;
  accountInfo: OAuthCardProps["accountInfo"];
  onApprove: () => Promise<string | undefined>;
  onDeny: () => Promise<string | undefined>;
}

export const OAuthConsentPageContent: FC<OAuthConsentPageContentProps> = ({
  redirectUri,
  clientId,
  scopeStr,
  responseType,
  appName,
  accountInfo,
  onApprove,
  onDeny,
}) => {
  if (!redirectUri || !clientId || !scopeStr || responseType !== "code") {
    return <OAuthCardError />;
  }

  return (
    <OAuthConsentPageForm
      appName={appName}
      scopeStr={scopeStr ?? undefined}
      accountInfo={accountInfo}
      handleApprove={onApprove}
      handleDeny={onDeny}
    />
  );
};
